interface IZordUtil {
    webPath: (url: string) => string
    contatoValido: (value?: string) => boolean
}

const ZordFunctions: () => IZordUtil = () => {
    return {
        webPath: (url) => {
            const cleanUrl = url.startsWith('/') ? url.slice(1) : url
            return `${globalThis.window.location.origin}/${cleanUrl}`
        },
        contatoValido: (value?: string): boolean => {
            if (!value) return false
            const digits = value.replace(/\D/g, '')
            return digits.length >= 10 && digits.length <= 11
        }
    }
}

export const ZordUtil: IZordUtil = ZordFunctions()